import $ from 'jquery';

function turnOnFullscreenMode(): void {
    const isFullScreenModeAvailable = document.fullscreenEnabled;
    if (isFullScreenModeAvailable) {
        const iframe = document.querySelector('#gameIframe') as HTMLIFrameElement;
        iframe.requestFullscreen();
    }
}

$('.iframeFullScreen').on('click', () => {
    if (/iPad|iPhone/.test(navigator.userAgent)) {
        $('#gameIframe').closest('.iframe-container').addClass('iOS');
        $('.page-footer, .container-fluid').hide();
        $('#app').css('margin-top', '0');
    } else {
        turnOnFullscreenMode();
    }
});
